import { PriceObjectDtoSchema } from "@modules/common/priceObject/gateway/priceObjectApiDto"
import { HUImageDtoSchema } from "@modules/dtos/imageDto"
import { UserDtoSchema } from "@modules/profile/userProfile/userDto"
import {
  ProgramStatus,
  ProgramSubscriptionStatus,
  ProgramType,
  ProgramVisibility,
  SharedCoachStatus,
} from "@modules/programs/types/programTypes"
import { z } from "zod"

export const UserProgramItemDtoSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    description: z.string(),
    image: HUImageDtoSchema.nullable(),
    owner: UserDtoSchema.nullable(),
    visibility: z.lazy(() => z.enum(ProgramVisibility)),
    subscribed: z.boolean(),
    subscriptionCount: z.number(),
    subscriptionStatus: z.lazy(() => z.enum(ProgramSubscriptionStatus).nullable()),
    price: PriceObjectDtoSchema.nullable(),
    defaultHideSessionContent: z.boolean(),
    status: z.lazy(() => z.enum(ProgramStatus)),
    duration: z.number().nullable(),
    type: z.lazy(() => z.enum(ProgramType)),
    sharedCoachStatus: z.lazy(() => z.enum(SharedCoachStatus).nullable()),
    followedInBundle: z.boolean(),
  })
  .meta({ id: "UserProgramItemDtoSchema" })

export type UserProgramItemDto = z.infer<typeof UserProgramItemDtoSchema>
